module.exports = __webpack_public_path__ + "static/assets/35cd02ee1489b2295f42db8706531fa1.svg";